module.exports = __webpack_public_path__ + "static/img/iEMS-icon.fface1ee.png";